import { createAction, props } from '@ngrx/store';

export const updateScreenerData = createAction(
  'OSMA-Screener',
  props<{
    advisor: any;
    client: any;
    accounts: any;
    asset: any;
  }>()
);
